import classNames from 'classnames';
import PropTypes from 'prop-types';

import Accordion from './Accordion';
import Body from './Body';

import styles from '../../../styles/partials/accordions.module.scss';

const propTypes = {
    className: PropTypes.string,
    itemClassName: PropTypes.string,
    itemLabelClassName: PropTypes.string,
    itemInnerClassName: PropTypes.string,
    items: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            body: PropTypes.string,
        }),
    ),
    icon: PropTypes.oneOf(['arrow', 'plus']),
    withoutCollapse: PropTypes.bool,
};

const defaultProps = {
    className: null,
    itemClassName: null,
    itemLabelClassName: null,
    itemInnerClassName: null,
    items: null,
    icon: null,
    withoutCollapse: false,
};

function Accordions({
    className,
    itemClassName,
    itemLabelClassName,
    itemInnerClassName,
    items,
    icon,
    withoutCollapse,
}) {
    return (
        <div className={classNames([styles.container, className])}>
            {(items || []).map(({ title, body }, itemI) => (
                <Accordion
                    key={`accordion-${itemI + 1}`}
                    className={classNames([
                        styles.item,
                        { [itemClassName]: itemClassName !== null },
                    ])}
                    labelClassName={classNames([
                        styles.itemLabel,
                        { [itemLabelClassName]: itemLabelClassName !== null },
                    ])}
                    innerClassName={classNames([
                        styles.itemInner,
                        { [itemInnerClassName]: itemInnerClassName !== null },
                    ])}
                    withoutCollapse={withoutCollapse}
                    label={title}
                    icon={icon}
                >
                    <Body body={body} />
                </Accordion>
            ))}
        </div>
    );
}

Accordions.propTypes = propTypes;
Accordions.defaultProps = defaultProps;

export default Accordions;
